module.exports = __webpack_public_path__ + "static/img/WashingtonInshore-RA.45c10e4.png";